module.exports = __webpack_public_path__ + "static/media/3.afe2d7f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/3.svg
// module id = 124
// module chunks = 0